export default "__VITE_ASSET__26445bb9__"